export default function Embed({url, ...rest}) {
    return (
        <iframe src={url} frameBorder="0" className="w-screen h-screen" {...rest}/>
    )
}